module.exports = __webpack_public_path__ + "static/img/Cow.fcd5f4cd.png";